import React from 'react';

import { SkeletonBody, SkeletonButton, SkeletonProfileImage } from '@xingternal/skeleton';

import companyContactStyles from './../../company-contact.css';
import styles from './contact-skeleton.css';

const ContactSkeleton: React.FC = () => (
  <div className={companyContactStyles.companyContact}>
    <div className={styles.userInfoSkeleton}>
      <SkeletonProfileImage className={styles.profileImage} />

      <div className={styles.body}>
        <SkeletonBody amountRows={3} />
      </div>
    </div>

    <SkeletonButton size="small" />
  </div>
);

export default ContactSkeleton;
